import api from '@/store/helpers/api';

let retries = 0;

async function wait(ms) {
  return new Promise((resolve) => {
    retries += 1;
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

const initialState = {
  loading: false,
  rondo: 0,
  quiz: 0,
  cards: 0,
};

const getters = {};

const actions = {
  async get({ commit, dispatch }) {
    commit('LOADSTART');
    if (!api.defaults.headers.common.Authorization && retries < 5) {
      await wait(300);
      return dispatch('get');
    }

    retries = 0;
    return api.get('/stats')
      .then((data) => {
        commit('SET', data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          setTimeout(() => {
            dispatch('get');
          }, 500);
        }
      })
      .finally(() => {
        commit('LOADEND');
      });
  },
};

const mutations = {
  LOADSTART(state) {
    state.loading = true;
  },
  LOADEND(state) {
    state.loading = false;
  },
  SET(state, data) {
    state.quiz = data.quiz;
    state.rondo = data.rondo;
    state.cards = data.tinder;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
